<!-- src/components/index.vue -->

<template>
  <section>
    <div class="container">
      <ul class="row justify-content-center no-gutters align-items-center text-center m-0">
        <li v-if="userSettings?.artTableActive !== 'false'" class="col-3 align-self-center m-0 subTitleFont p-0"  @click="toggleSection('images')" ><h5 :class="{ 'textmaintoggle': activeSection === 'images' }" class="textmainhover">Artwork</h5></li>
        <li v-if="userSettings?.feedTableActive !== 'false'" class="col-3 align-self-center m-0 subTitleFont p-0"  @click="toggleSection('journals')"><h5 :class="{ 'textmaintoggle': activeSection === 'journals' }" class="textmainhover">Feed</h5></li>
      </ul>
    </div>
    <ProfilePagePart3YearsList v-if="activeSection === 'images'" :userId="userId" :userSettings="userSettings" />
  </section>
</template>

<script>
  import 'bootstrap/dist/css/bootstrap.min.css';
  import ProfilePagePart3YearsList from '@/ProfilePagePart3YearsList.vue';
  export default {
    name: 'App',
    props: ['userId', 'userSettings'], // Accept both userId and userSettings as props
    components: {
    ProfilePagePart3YearsList,
    },
    // Hide the data until user selects it
    data() {
      return {
        activeSection: null,
      };
    },
    methods: {
      toggleSection(property) {
        //console.log('Toggling', property);
        this.activeSection = property;
      },
    },
    mounted(){
      
    },
    created() {
    
    },
  }
</script>
